module.exports = __webpack_public_path__ + "img/users-icon.69511880.svg";